import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentLockClosed: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
    <Path
      d='M12 2a4 4 0 014 4v2h1.75A2.25 2.25 0 0120 10.25v9.5A2.25 2.25 0 0117.75 22H6.25A2.25 2.25 0 014 19.75v-9.5A2.25 2.25 0 016.25 8H8V6a4 4 0 014-4zm5.75 7.5H6.25a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h11.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75zm-5.75 4a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-10A2.5 2.5 0 009.5 6v2h5V6A2.5 2.5 0 0012 3.5z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentLockClosed
